import { WebFinger } from './client-info.interface';

export interface Provider {
  redirectUri: string;
  displayName: string;
  logoUrl?: string;
}

export type UserCheckAction = 'redirect' | 'login' | 'register' | 'select' | 'blocked';


export interface UserCheckAPIRequest {
  requestId: string;
  username?: string;
  customFields?: { [key: string]: string };

  webfinger?: WebFinger;
  rememberMe?: boolean;
}

export type UserCheckResultV1 = UserCheckResult | boolean;



export const isUserCheckResult = (value: UserCheckResultV1): value is UserCheckResult => {
  return typeof value !== 'boolean';
};

export const mapToUserCheckResult = (value: UserCheckResultV1): UserCheckResult => {
  if (isUserCheckResult(value)) {
    return value;
  }
  return {
    action: value && 'login' || 'register'
  };
};


export interface UserCheckResult {
  action: UserCheckAction;
  providers?: Provider[];
}
